/**
 * Format To Pixel
 *
 * Convert integer value into pixel. Does not scale the number.
 *
 * @param {int} value: number to format
 * @returns {string}: formatted amount with pixel format or the original value
 */

export const formatToPx = (value?: string | number) =>
  typeof value === 'number' ? `${value}px` : value

/**
 * toPx - template function
 *
 * Convert integer value into pixel. Does not scale the number.
 *
 * @param {array} strings: an array of raw strings
 * @param {string | number} literals: template literal string or int values
 * @returns {string}: formatted amount with pixel format or the original value
 *
 * @example: border: toPx`${borderThickness} solid ${color}`
 */
export default (strings: TemplateStringsArray, ...literals: (string | number)[]) => {
  let string = strings[0]

  literals.forEach((literal, idx) => {
    string += `${formatToPx(literal)}${strings[idx + 1]}`
  })

  return string
}
